// A command over HTTP when the screen needs its answer (a check, a calculation): the socket only says whether it was applied.
export async function command<T>(name: string, input: unknown): Promise<{ ok: true; result: T } | { ok: false; message: string }> {
  const r = await fetch(`/api/commands/${name}`, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(input) });
  const body = await r.json().catch(() => ({})) as { result?: T; error?: { message: string } };
  return r.ok ? { ok: true, result: body.result as T } : { ok: false, message: body.error?.message ?? 'Не получилось' };
}
